import { IconBuilding } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { Outlet } from 'react-router'
import { FixedPageTitle } from '@/components/layout/PageWithFixedToolbar/FixedPageTitle'
import { PageWithFixedToolbar } from '@/components/layout/PageWithFixedToolbar/PageWithFixedToolbar'

export const TowerPage = () => {
  return (
    <PageWithFixedToolbar
      maxWidth={1400}
      toolbar={
        <FixedPageTitle
          title={<FormattedMessage id="tower.title" />}
          icon={<IconBuilding size={24} />}
        />
      }
    >
      <Outlet />
    </PageWithFixedToolbar>
  )
}
